import {
  MORAL_LIST_SEARCH, MORAL_LIST_SEARCH_FAILURE, MORAL_LIST_SEARCH_SUCCESS, MORAL_DELETE, MORAL_DELETE_FAILURE, MORAL_DELETE_SUCCESS
} from './mutation-types'

export default {
  state: {
    morals: [],
    moralListNextPage: null,
    moralListCurrentPage: null
  },
  getters: {
    moralList: state => {
      return state.morals
    },
    moralListNextPage: state => {
      return state.moralListNextPage
    },
    moralListCurrentPage: state => {
      return state.moralListCurrentPage
    }
  },
  actions: {
    [MORAL_LIST_SEARCH] ({dispatch, state, commit}, params) {
      var data = {}
      var url = '/master/morals'
      var callback = () => {}
      if (params) {
        if (params.url) {
          url = params.url
        }
        if ('callback' in params) {
          callback = params.callback
        }
        data = params.data
      }
      dispatch('apiGet', {url: url, data: data, loadparams: true})
      .then(res => {
        if (res.status === 200 || res.status === 304) {
          if (res.data.error) {
            commit(MORAL_LIST_SEARCH_FAILURE, {data: res.data, callback: callback})
          } else {
            commit(MORAL_LIST_SEARCH_SUCCESS, {data: res.data, callback: callback})
          }
        }
      })
      .catch(error => {
        throw error
      })
    },
    [MORAL_DELETE] ({dispatch, state, commit}, params = null) {
      console.log('MORAL_DELETE:' + params.id)
      var data = params.data
      var url = '/master/morals/' + params.id
      dispatch('apiDelete', {url: url, data: data})
      .then(res => {
        if (res.status === 200 || res.status === 304) {
          if (res.data.error) {
            commit(MORAL_DELETE_FAILURE, res.data)
          } else {
            commit(MORAL_DELETE_SUCCESS, {data: res.data, callback: params.callback})
            window.location.reload(false)
          }
        }
      })
      .catch(error => {
        throw error
      })
    }
  },
  mutations: {
    [MORAL_LIST_SEARCH_FAILURE] (state, params) {
      console.log('MORAL_LIST_SEARCH_FAILURE')
      if (params.callback) {
        params.callback()
      }
    },
    [MORAL_LIST_SEARCH_SUCCESS] (state, params) {
      console.log('MORAL_LIST_SEARCH_SUCCESS')
      var data = params.data
      if (data.meta && data.meta['current-page'] && data.meta['current-page'] > 1) {
        state.morals = state.morals.concat(data.data)
        state.moralListCurrentPage = data.meta['current-page']
      } else {
        state.morals = data.data
        state.moralListCurrentPage = 1
      }
      if (data.links && data.links['next']) {
        state.moralListNextPage = data.links['next']
      } else {
        state.moralListNextPage = null
      }
      if (params.callback) {
        params.callback()
      }
    },
    [MORAL_DELETE_FAILURE] (state, data) {
      console.log('MORAL_DELETE_FAILURE')
    },
    [MORAL_DELETE_SUCCESS] (state, data) {
      console.log('MORAL_DELETE_SUCCESS')
      var callback = data.callback
      callback()
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/moral-list.js